require('script-loader!.tmp/js/templates/common/modules/InlineRatings.js');
require('script-loader!.tmp/js/templates/common/modules/Icons.js');

import fetchJsonp from 'fetch-jsonp';

export const GetInlineRatings = async () => {
  const globalConfig = JSON.parse(document.querySelector('.js-bv-config').innerHTML);
  const productIds = [];
  const idToRatingElMap = {};

  for (const ratingEl of document.querySelectorAll('.js-ratings-wrapper')) {
    const config = JSON.parse(ratingEl.querySelector('.js-rating-bv-config').innerHTML);
    const productId = config.id;
    if (isValidProductId(productId)) {
      productIds.push(productId);
      idToRatingElMap[productId] = ratingEl;
    }
  }

  const ratings = await getRatings(globalConfig, productIds);
  if (ratings) {
    renderRatings(ratings, idToRatingElMap, globalConfig);
  }
};

const getRatings = async (globalConfig, productIds) => {
  const res = await getRatingsResponse(globalConfig, productIds.join(','));
  if (res.hasErrors || !res.TotalResults) {
    if (res.hasErrors) {
      console.log(res.Errors);
    }
    return;
  }
  return res.Results;
};

const getRatingsResponse = async (config, productIdsString) => {
    const urlBase = `https://${config.isStaging ? 'stg.' : ''}api.bazaarvoice.com/data/`;
    const params = `apiversion=5.4&passkey=${config.key}&Filter=ProductId:${productIdsString}`;
    const statsUrl = `${urlBase}statistics.json?${params}&stats=NativeReviews,Reviews`;
    try {
      const response = await fetchJsonp(`${statsUrl}`);
      return response.json();
    } catch(err) {
      console.log(err);
      return Promise.reject(err);
    }
};

const renderRatings = (ratings, idToRatingElMap, globalConfig) => {
  for (const rating of ratings) {
    const ratingData = rating.ProductStatistics.ReviewStatistics;
    const productId = rating.ProductStatistics.ProductId;
    const ratingEl = idToRatingElMap[productId];
    ratingData.baseUrl = globalConfig.baseUrl;
    ratingEl.innerHTML = common.modules.InlineRatings(ratingData);
  }
};

const isValidProductId = (num) => {
  return num.length === 14;
};
